/**
 * Mobile drill-down menu, fed by the hidden tree markup.
 */
export function initNavMobile() {
  const header = document.querySelector('.mdh');
  const burger = document.querySelector('.mdh__burger');
  const container = document.querySelector('.mdh__mobile');
  if (!header || !burger || !container) {
    return;
  }
  const tree = container.querySelector('.mdh__mobile-tree > ul');
  const panelsEl = container.querySelector('.mdh__mobile-panels');
  const breadcrumbsEl = container.querySelector('.mdh__mobile-breadcrumbs');
  if (!tree || !panelsEl || !breadcrumbsEl) {
    return;
  }

  let path = [];

  burger.addEventListener('click', () => {
    const open = !container.classList.contains('mdh__mobile--open');
    container.classList.toggle('mdh__mobile--open', open);
    burger.classList.toggle('mdh__burger--active', open);
    header.classList.toggle('mdh--menu-open', open);
    burger.setAttribute('aria-expanded', String(open));
    if (!open) {
      path = [];
    }
    update();
  });

  panelsEl.addEventListener('click', (event) => {
    const item = event.target.closest('.has-children');
    if (item && item.sourceLi) {
      path.push(item.sourceLi);
      update();
    }
  });

  breadcrumbsEl.addEventListener('click', (event) => {
    const crumb = event.target.closest('.breadcrumb-item');
    if (!crumb) {
      return;
    }
    const index = Number(crumb.dataset.index);
    if (index < path.length) {
      path = path.slice(0, index);
      update();
    }
  });

  function labelOf(li) {
    const link = li.querySelector(':scope > a');
    return link ? link.textContent.trim() : '';
  }

  function ulChain() {
    const chain = [tree];
    path.forEach((li) => {
      const ul = li.querySelector(':scope > ul');
      if (ul) {
        chain.push(ul);
      }
    });
    return chain;
  }

  function renderPanels() {
    const chain = ulChain();
    const fragment = document.createDocumentFragment();

    chain.forEach((ul) => {
      const panel = document.createElement('div');
      panel.className = 'panel';
      const list = document.createElement('ul');

      Array.from(ul.children).forEach((li) => {
        const sourceLink = li.querySelector(':scope > a');
        const hasChildren = !!li.querySelector(':scope > ul');
        const item = document.createElement('li');

        if (hasChildren) {
          item.className = 'has-children';
          item.innerHTML = '<div class="item-row"><span class="item-title"></span><span class="arrow">›</span></div>';
          item.sourceLi = li;
        } else {
          item.innerHTML = '<a><div class="item-row"><span class="item-title"></span></div></a>';
          const link = item.querySelector('a');
          link.href = sourceLink ? sourceLink.getAttribute('href') : '#';
          if (sourceLink && sourceLink.target) {
            link.target = sourceLink.target;
          }
        }

        item.querySelector('.item-title').textContent = labelOf(li);
        list.appendChild(item);
      });

      panel.appendChild(list);
      fragment.appendChild(panel);
    });

    panelsEl.replaceChildren(fragment);
    panelsEl.style.transform = `translateX(-${(chain.length - 1) * 100}%)`;
  }

  function renderBreadcrumbs() {
    const labels = ['Main', ...path.map(labelOf)];
    const fragment = document.createDocumentFragment();

    labels.forEach((label, index) => {
      const crumb = document.createElement('span');
      crumb.className = 'breadcrumb-item';
      crumb.textContent = label;
      crumb.dataset.index = String(index);
      fragment.appendChild(crumb);
      if (index < labels.length - 1) {
        fragment.appendChild(document.createTextNode(' / '));
      }
    });

    breadcrumbsEl.replaceChildren(fragment);
  }

  function update() {
    renderPanels();
    renderBreadcrumbs();
  }

  update();
}
